import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1497337765421439';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Defer the pixel until the page is idle so it doesn't block LCP/FID
    const loadPixel = () => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
        return;
      }
      const fbq: any = function (...args: any[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args);
        } else {
          fbq.queue.push(args);
        }
      };
      (window as any).fbq = fbq;
      if (!(window as any)._fbq) (window as any)._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', PIXEL_ID);
      fbq('track', 'PageView');
    };
    const idle: any = (window as any).requestIdleCallback;
    if (typeof idle === 'function') {
      idle(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return null;
}